import { useEffect, useState } from 'react'
import { ApplicationQuestionnaire, company, customerData } from '../../utilities/CustomerData'
import { AdvancePaymentQuestionnaire } from './RefundCalculatedSteps/AdvancePaymentQuestionnaire'
import { AdvancePaymentESign } from './RefundCalculatedSteps/AdvancePaymentESign'
import { AdvancePaymentESignAgreement } from './RefundCalculatedSteps/AdvancePaymentESignAgreement'
import { AdvancePaymentSpouseESign } from './RefundCalculatedSteps/AdvancePaymentSpouseESign'

export function ESign() {
  const [step, setStep] = useState(0)
  const [applicationQuestionnaire, setApplicationQuestionnaire] = useState(new ApplicationQuestionnaire())
  const [spouseApplicationQuestionnaire, setSpouseApplicationQuestionnaire] = useState(new ApplicationQuestionnaire())
  const [needSpouseAffidavit, setNeedSpouseAffidavit] = useState(customerData.customerDocuments.marriedFilingJoint && (!customerData.customerMultipleSourceIncome.didSpouseCalculation))

  /**
   * @param {ApplicationQuestionnaire} applicationQuestionnaire
   * @param {ApplicationQuestionnaire} spouseApplicationQuestionnaire
   */
  const handleCompleteQuestionnaire = (applicationQuestionnaire, spouseApplicationQuestionnaire) => {
    setApplicationQuestionnaire(applicationQuestionnaire)
    setSpouseApplicationQuestionnaire(spouseApplicationQuestionnaire)
    setStep(step+1)
  }

  useEffect(() => {
    if(applicationQuestionnaire.businessName)
      setStep(step + 1)
  }, [applicationQuestionnaire])

  useEffect(() => {
    document.title = `${company.companyName} | E-Sign`
  }, [])

  return (
    <div className='w-screen flex flex-col items-center font-mont'>
      {step === 0 ? (
        <AdvancePaymentESignAgreement
          step={step}
          setStep={setStep}
        />
      ) : step === 1 ? (
        needSpouseAffidavit ? (
          <AdvancePaymentSpouseESign
            setNeedSpouseAffidavit={setNeedSpouseAffidavit}
          />
        ) : (
          <AdvancePaymentQuestionnaire
            handleCompleteQuestionnaire={handleCompleteQuestionnaire}
          />
        )
      ) : (
        <AdvancePaymentESign
          needSpouseAffidavit={needSpouseAffidavit}
          applicationQuestionnaire={applicationQuestionnaire}
          spouseApplicationQuestionnaire={spouseApplicationQuestionnaire}
        />
      )}
    </div>
  )
}